module.exports = __webpack_public_path__ + "media/images/google-play-badge-6719dbfca6574b355c1bdf1bff049459.svg";